import { useContext, useEffect } from "react";
import { SetRevealingIdsContext } from "./textRevealState/SetRevealingIdsContext";
import { withId } from "./textRevealState/withId";

/** Reports one bubble's reveal state. A no-op with no provider. */
export const useReportTextReveal = (id: string, revealing: boolean) => {
  const setIds = useContext(SetRevealingIdsContext);

  useEffect(() => {
    if (!setIds) {
      return;
    }
    setIds((current) => withId(current, id, revealing));
    return () => setIds((current) => withId(current, id, false));
  }, [id, revealing, setIds]);
};
